// An FX hedge is priced in the quote half of its pair — the "USD" of EUR/USD —
// so every FX booking form derives the executed-price currency from the pair
// rather than asking for it. One home so the two booking paths cannot drift.
export function fxQuoteCurrency(pair: string | null): string | undefined {
  const quote = pair?.split('/')[1]?.trim().toUpperCase();
  return quote?.length === 3 ? quote : undefined;
}

const CURRENCY_CODES = new Set(Intl.supportedValuesOf('currency'));

export function fxBaseCurrency(pair: string | null): string | undefined {
  const match = /^([A-Z]{3})\/?([A-Z]{3})$/.exec(pair?.replace(/\s/g, '').toUpperCase() ?? '');
  const base = match?.[1];
  const quote = match?.[2];
  return base !== undefined &&
    quote !== undefined &&
    CURRENCY_CODES.has(base) &&
    CURRENCY_CODES.has(quote)
    ? base
    : undefined;
}
